import classNames from 'classnames';
import { memo, useCallback, useState } from 'react';

import { PlayIcon } from '@/lib/v2/icons/general';

type PlayVideoProps = {
  /** use embed video url or watch url youtube */
  videoUrl?: string;
  /** custom portrait image */
  portraitImage?: string;
  enableBorder?: boolean;
};

const PlayVideo = ({ videoUrl, portraitImage, enableBorder }: PlayVideoProps) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const containerClasses = classNames('relative aspect-video w-full rounded-lg overflow-hidden', {
    'bg-emblue-app-background': !portraitImage,
    'bg-transparent': portraitImage,
    'border border-emblue-borders': enableBorder,
  });

  const handlePlayClick = useCallback(() => {
    setIsPlaying(true);
  }, []);

  // const convertToEmbedUrl = useCallback((url: string): string => {
  //   const videoIdMatch = url.match(/(?:\?v=|\/embed\/|\/v\/|youtu\.be\/)([\w-]{11})/);
  //   return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}` : url;
  // }, []);

  // const embedUrl = videoUrl ? convertToEmbedUrl(videoUrl) : undefined;

  return (
    <div
      className={containerClasses}
      style={{
        backgroundImage: `url(${portraitImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex size-full items-center justify-center">
        {!isPlaying && videoUrl && (
          <button onClick={handlePlayClick}>
            <PlayIcon />
          </button>
        )}
        {isPlaying && videoUrl && (
          <iframe
            allowFullScreen
            allow="autoplay; fullscreen"
            className="absolute inset-0 size-full"
            src={videoUrl}
            title="Video Player"
          ></iframe>
        )}
      </div>
    </div>
  );
};

export default memo(PlayVideo);
